import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledVideoThumbnailItemComponent } from "./video-thumbnail-item-component.scss";
import PlayButtonIcon from "/static/svg/videos/video-play-button.svg";
import { getAssetPath } from "/services/assets-service";
class VideoThumbnailItemComponent extends PureComponent {
    onClick() {
        const { index, onClick } = this.props;
        onClick(index);
    }
    render() {
        const { title, thumbnailSrc } = this.props;
        return /*#__PURE__*/ _jsxs(StyledVideoThumbnailItemComponent, {
            className: "video-thumbnail-item-component",
            onClick: this.onClick,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "thumbnail-image-part",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "thumbnail-image",
                            style: {
                                backgroundImage: `url(${getAssetPath(thumbnailSrc)})`
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "play-icon-container",
                            children: /*#__PURE__*/ _jsx(PlayButtonIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "thumbnail-text-part",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "video-title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "link-indicator",
                            children: "Watch video"
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
}
export { VideoThumbnailItemComponent as default };
